export const formatHandleName = (name: string) =>
  ({
    greb: 'Greb',
    stropper: 'Stropper',
    baerestaenger: 'Bærestænger',
  })[name] ?? 'Greb'
